import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-report-dock-download-video",
  "use": "icon-report-dock-download-video-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\" id=\"icon-report-dock-download-video\">\n  <path d=\"M3 4h11v7H3V4zm12 1.5L20 9v-6l-5 2.5V5.5z\" />\n  <path d=\"M12 14l-3 3h2v4h2v-4h2l-3-3z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/report/report-dock-download-video.svg
// module id = G/5h
// module chunks = 24